import styled from '@mui/material/styles/styled';
import { theme } from '@/theme';

export const Container = styled('div')`
  max-width: 450px;
  ${theme.breakpoints.down('sm')} {
    min-width: unset;
  }
`;
